import SnackbarMessage from "@/components/SnackbarMessage/SnackbarMessage.vue";

export default {
  name: "PasswordResetComplete",
  components: { SnackbarMessage },
  data() {
    return ({
      success_message: "Your password has been reset successfully!",
    });
  }
};
